<!-- TodaySummaryTable.vue -->
<template>
  <div>
      <div class="table-container">
        <b-table
          striped
          hover
          :items="pagedItems"
          :fields="fields"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          class="custom-table"
          :thead-row-class="'custom-table-header-row'"
        >
          <template #cell(index)="data">
            {{ (currentPage - 1) * perPage + data.index + 1 }}
          </template>
          <template #cell(DepositCount)="data">
            {{ formatNumber(data.item.DepositCount) }}
          </template>
          <template #cell(TotalTransactionValue)="data">
            {{ formatDecimal(data.item.TotalTransactionValue) }}
          </template>
          <template #cell(actions)="data">
            <el-button size="small" type="primary" @click="detailItem(data.item)">
              See more
            </el-button>
          </template>
        </b-table>
    
        <div class="d-flex justify-content-between align-items-center mt-3">
          <div class="d-flex align-items-center">
            <label class="mr-2">{{ `Showing ${((currentPage - 1) * perPage) + 1} to ${Math.min(currentPage * perPage, totalRows)} of ${totalRows} rows` }}</label>
            <b-form-group label-class="sr-only" class="mb-0">
              <b-form-select
                v-model="perPage"
                :options="perPages"
                ref="perPageSelect"
                @shown="adjustDropdownHeight"
              ></b-form-select>
            </b-form-group>
          </div>
          <div>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @input="pageChanged"
            ></b-pagination>
          </div>
        </div>

        <Loader v-if="loading" />
      </div>


      <TodaySummaryByDateDialog :dialogVisible.sync="dialogVisible" :depositDate="depositDate"  :stationlist="stationlist"/>

  </div>
</template>

<script>
import TodaySummaryByDateDialog from '@/views/pages/Finance/CashDeposit/Report/TodaySummaryByDateDialog.vue'
import Loader from '@/components/loader/Loader2.vue'

export default {
  components: { 
      TodaySummaryByDateDialog,
      Loader
  },
  props: {
      items: {
          type: Array,
          required: false,
      },
      loading: {
          type: Boolean,
          default: false,
          required: false,
		}, 
		stationlist : { 
		type: Array,
		default: () => ({}),
		required: false,
	},
},
  data() {
      return {
          dialogVisible: false,
          depositDate: '',

          fields: [
              { key: 'index', label: '#', sortable: false, thClass: 'text-center', tdClass: 'text-center' },
              { key: 'DepositDate', label: 'Deposit Date', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
              { key: 'TotalTransactionValue', label: 'Total Transaction Value', sortable: true, thClass: 'text-center', tdClass: 'text-right' },
              { key: 'DepositCount', label: 'Deposit Count', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
              { key: 'actions', label: '', sortable: false, thClass: 'text-center', tdClass: 'text-center' }
          ],
          currentPage: 1,
          perPage: 10,
          filter: '',
          totalRows: 0,
          sortBy: '',
          sortDesc: false,
          perPages: [10, 15, 20, 50, 100]
      };
  },
  computed: {
      pagedItems() {
          const startIndex = (this.currentPage - 1) * this.perPage;
          const endIndex = startIndex + this.perPage;
          return this.items.slice(startIndex, endIndex);
      }
  },
  mounted() {
      this.loadData();
  },
  methods: {
      loadData() {
          this.totalRows = this.items.length;
      },
      onFiltered(filteredItems) {
          this.totalRows = filteredItems.length;
      },
      formatNumber(value) {
          return new Intl.NumberFormat('en-US', { style: 'decimal', currency: 'USD' }).format(value);
      },
      formatDecimal(value) {
          return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value);
      },
      detailItem(item) {
          const index = this.items.indexOf(item);
          console.log('index: ' + index);
          this.dialogVisible = true;
          this.depositDate = item.DepositDate;
          console.log("this.depositDate: " + this.depositDate);
      },
      adjustDropdownHeight() {
          const paginationHeight = this.$refs.perPageSelect.$el.offsetHeight;
          this.$refs.perPageSelect.$el.style.height = `${paginationHeight}px`;
      },
      pageChanged(newPage) {
          this.currentPage = newPage;
      },
      
      isDate(value) {
        return !isNaN(Date.parse(value));
      },
      isNumeric(value) {
          return !isNaN(value);
      },
      splitAlphaNumeric(value) {
          const regex = /^([a-zA-Z\s]*)(\d*)$/;
          const match = value.match(regex);
          return match ? [match[1].toLowerCase(), parseInt(match[2] || '0', 10)] : [value, 0];
      },

      sortData() {
          if (this.sortBy) {
              this.items.sort((a, b) => {
                  const modifier = this.sortDesc ? -1 : 1;
                  let valueA = a[this.sortBy];
                  let valueB = b[this.sortBy];

                  if (this.isDate(valueA) && this.isDate(valueB)) {
                      valueA = new Date(valueA);
                      valueB = new Date(valueB);
                  } else if (this.isNumeric(valueA) && this.isNumeric(valueB)) {
                      valueA = parseFloat(valueA);
                      valueB = parseFloat(valueB);
                  } else {
                      const [alphaA, numericA] = this.splitAlphaNumeric(valueA);
                      const [alphaB, numericB] = this.splitAlphaNumeric(valueB);

                      if (alphaA < alphaB) return -1 * modifier;
                      if (alphaA > alphaB) return 1 * modifier;
                      if (numericA < numericB) return -1 * modifier;
                      if (numericA > numericB) return 1 * modifier;
                      return 0;
                  }

                  if (valueA < valueB) return -1 * modifier;
                  if (valueA > valueB) return 1 * modifier;
                  return 0;
              });
          }
      },
  },
  watch: {
      items() {
          this.loadData();
      },
      sortBy() {
          this.sortData();
      },
      sortDesc() {
          this.sortData();
      }
  }
};
</script>

<style>
.custom-table thead th {
  height: 55px;
  vertical-align: middle !important;
  align-items: center;
}

.table-container {
  overflow-x: auto;
}
</style>
